module.exports = __webpack_public_path__ + "static/img/n-wast-check.c7701eed.png";